(() => {
  function towelRows(source) {
    if (source.title === 'Pack 6 Toalla Microfibra Peluquera Hotel Barberia Spa Gym Piso 40x80 cm') return [];
    const doc = new DOMParser().parseFromString(source.description, 'text/html');
    doc.querySelectorAll('br').forEach(br => br.replaceWith(doc.createTextNode('\n')));
    const text = doc.body.textContent.replace(/\s+/g, ' ');
    const pattern = /(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?/gi;
    const found = new Map();
    function collect(input) {
      for (const match of input.matchAll(pattern)) {
        const sides = [Number(match[1].replace(',', '.')), Number(match[2].replace(',', '.'))].sort((a,b) => a-b);
        if (sides.some(side => side <= 0 || side > 500)) continue;
        const value = sides.join(' × ') + ' cm';
        const prefix = input.slice(Math.max(0, match.index - 100), match.index);
        const labels = Array.from(prefix.matchAll(/\b(?:toall[oó]n|cuerpo|manos?|facial|cara)\b/gi));
        const last = labels.at(-1)?.[0].toLowerCase();
        const label = last === 'cuerpo' ? 'Toalla de cuerpo' : /manos?/.test(last || '') ? 'Toalla de manos' : /facial|cara/.test(last || '') ? 'Toalla facial' : /toall[oó]n/.test(last || '') ? 'Toallón' : 'Dimensiones';
        if (!found.has(value)) found.set(value, {label, value});
      }
    }
    collect(text);
    if (!found.size) collect(source.title);
    const result = Array.from(found.values());
    if (result.length === 1) result[0].label = 'Dimensiones';
    else result.forEach((row,index) => { if (row.label === 'Dimensiones') row.label = 'Medida '+(index+1); });
    return result;
  }

  function init(root = document) {
    root.querySelectorAll('[data-measure-guide]').forEach(guide => {
      if (guide.dataset.ready) return;
      const source = JSON.parse(guide.querySelector('[data-measure-source]').textContent);
      const rows = [];
      const seen = new Set();
      let currentSize = '';
      function add(label, value) {
        label = label.trim().replace(/^[•\s:–-]+|[:\s]+$/g, '');
        if (/^fuelle(?:\s+de)?$/i.test(label)) label='Alto / fuelle';
        value = value.trim();
        const key = (currentSize + label + value).toLowerCase();
        if (!label || !value || seen.has(key)) return;
        seen.add(key); rows.push({label, value, size:currentSize});
      }
      if (source.manual) {
        source.manual.split(/\n/).forEach(line => {
          const parts = line.split('|');
          if (parts.length > 1) add(parts[0], parts.slice(1).join('|'));
        });
      }
      if (!rows.length) {
        const doc = new DOMParser().parseFromString(source.description, 'text/html');
        doc.querySelectorAll('br').forEach(br => br.replaceWith(doc.createTextNode('\n')));
        const headings = Array.from(doc.body.querySelectorAll('h2,h3,h4')).filter(el => /^medidas|^dimensiones|^tallas/i.test(el.textContent.trim()));
        const sections = [];
        headings.forEach(heading => {
          let sibling = heading.nextElementSibling;
          while (sibling && !/^H[1-6]$/.test(sibling.tagName)) {
            sections.push(...(sibling.matches('p,tr,li') ? [sibling] : Array.from(sibling.querySelectorAll('li,p,tr'))));
            sibling = sibling.nextElementSibling;
          }
        });
        const leaves = (sections.length ? sections : Array.from(doc.body.querySelectorAll('li,p,tr,h2,h3,h4'))).filter(el => !el.querySelector('li,p,tr,h2,h3,h4'));
        const lines = leaves.length ? leaves.map(el => el.textContent) : [doc.body.textContent];
        const pattern = /(\d+(?:[.,]\d+)?(?:\s*[x×X]\s*\d+(?:[.,]\d+)?){0,2}(?:\s*\+\s*\d+(?:[.,]\d+)?)?\s*cm\b)/gi;
        lines.forEach(line => {
          line.split(/[\n;]|\.\s+/).forEach(part => {
            const sizeMatch = part.trim().match(/^talla\s*:?\s*(.+)$/i);
            if (sizeMatch && !/cm\b/i.test(part)) { currentSize = sizeMatch[1].trim(); return; }
            part = part.replace(/cm\s*([x×])\s*/gi, '$1 ');
            let match;
            let previousEnd = 0;
            while ((match = pattern.exec(part))) {
              let label = part.slice(previousEnd, match.index).trim().replace(/[:=]\s*$/, '');
              label = label.replace(/^.*?[•]/, '').trim();
              if (label.length > 100) label = label.slice(-100).replace(/^\S*\s/, '');
              add(label || 'Medida del producto', match[1]);
              previousEnd = pattern.lastIndex;
            }
          });
        });
      }
      const towel = source.towel_collection === true || /toalla|toall[oó]n/i.test(source.title);
      if (towel) {
        rows.splice(0, rows.length, ...towelRows(source));
        guide.querySelector('.emg-product').textContent = 'Guía de medidas de toallas';
      }
      if (rows.length > 1 && rows.every(row => row.value.replace(/\s/g,'') === rows[0].value.replace(/\s/g,''))) {
        const value = rows[0].value;
        rows.splice(0, rows.length, {label:'Dimensiones', value});
      }
      if (!rows.length) {
        document.querySelectorAll('.enigma-size-guide').forEach(button => button.hidden = true);
        return;
      }
      guide.dataset.ready = 'true';
      const body = guide.querySelector('[data-measure-rows]');
      const sizes = [...new Set(rows.map(row => row.size).filter(Boolean))];
      const selectedId=document.querySelector('#product-template [name="id"]')?.value || source.selected_variant_id;
      const selectedVariant=source.variants?.find(variant=>String(variant.id)===String(selectedId));
      const selectedSize=sizes.find(size=>selectedVariant?.options?.some(option=>String(option).toLowerCase()===size.toLowerCase()));
      if(selectedSize){const activeRows=rows.filter(row=>!row.size || row.size===selectedSize);rows.splice(0,rows.length,...activeRows);}
      if (sizes.length > 1 && !selectedSize) {
        const head = guide.querySelector('.emg-table thead tr');
        head.replaceChildren();
        ['Medida', ...sizes].forEach(label => { const th=document.createElement('th');th.scope='col';th.textContent=label;head.append(th); });
        const labels = [...new Set(rows.filter(row=>row.size).map(row=>row.label))];
        labels.forEach(label => {
          const tr=document.createElement('tr');
          const th=document.createElement('th');th.scope='row';th.textContent=label;tr.append(th);
          sizes.forEach(size => { const td=document.createElement('td');td.textContent=rows.find(row=>row.size===size && row.label===label)?.value || '—';tr.append(td); });
          body.append(tr);
        });
        guide.querySelector('.emg-table caption').textContent='Comparativa de tallas';
      } else {
        rows.forEach(row => {
          const tr=document.createElement('tr');
          const th=document.createElement('th');th.scope='row';th.textContent=row.label;
          const td=document.createElement('td');td.textContent=row.value;
          tr.append(th,td);body.append(tr);
        });
      }
      const graph = guide.querySelector('[data-measure-graph]');
      const robe = source.kind === 'robe' || source.kind === 'auto' && /bata|polera|camiseta|pantal[oó]n|ropa t[eé]rmica/i.test(source.title);
      const ns = 'http://www.w3.org/2000/svg';
      function svgBase(shape) {
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('viewBox', '0 0 320 300'); svg.setAttribute('role', 'img');
        const title = document.createElementNS(ns, 'title'); title.textContent = 'Esquema de medidas: ' + source.title; svg.append(title);
        const path = document.createElementNS(ns, 'path'); path.setAttribute('d', shape); path.setAttribute('fill', '#fff'); path.setAttribute('stroke', '#282828'); path.setAttribute('stroke-width', '1.5'); svg.append(path); return svg;
      }
      function arrow(svg, x1, y1, x2, y2, label, tx, ty) {
        const line = document.createElementNS(ns, 'path');
        const vertical = x1 === x2;
        line.setAttribute('d', vertical ? 'M'+x1+' '+y1+'V'+y2+' M'+(x1-4)+' '+(y1+5)+'L'+x1+' '+y1+'L'+(x1+4)+' '+(y1+5)+' M'+(x2-4)+' '+(y2-5)+'L'+x2+' '+y2+'L'+(x2+4)+' '+(y2-5) : 'M'+x1+' '+y1+'H'+x2+' M'+(x1+5)+' '+(y1-4)+'L'+x1+' '+y1+'L'+(x1+5)+' '+(y1+4)+' M'+(x2-5)+' '+(y2-4)+'L'+x2+' '+y2+'L'+(x2-5)+' '+(y2+4));
        if (x1 !== x2 && y1 !== y2) {
          const angle=Math.atan2(y2-y1,x2-x1), length=6;
          const point=(x,y,a)=>[x+length*Math.cos(a),y+length*Math.sin(a)].join(' ');
          line.setAttribute('d','M'+x1+' '+y1+'L'+x2+' '+y2+' M'+point(x1,y1,angle-.55)+'L'+x1+' '+y1+'L'+point(x1,y1,angle+.55)+' M'+point(x2,y2,angle+Math.PI-.55)+'L'+x2+' '+y2+'L'+point(x2,y2,angle+Math.PI+.55));
        }
        line.setAttribute('fill','none'); line.setAttribute('stroke','#555'); svg.append(line);
        const text = document.createElementNS(ns,'text'); text.setAttribute('x',tx); text.setAttribute('y',ty); text.setAttribute('text-anchor','middle'); text.textContent=label; svg.append(text);
      }
      if (robe) {
        const svg = svgBase('M125 48L85 65L52 124L83 140L104 103L96 252H224L216 103L237 140L268 124L235 65L195 48L178 76H142Z M125 48L160 133L195 48 M160 133V252 M102 166H218 M115 181H139V209H115Z M181 181H205V209H181Z');
        const long = rows.find(r => /largo/i.test(r.label));
        const width = rows.find(r => /espalda|pecho|ancho/i.test(r.label));
        const sleeve = rows.find(r => /manga/i.test(r.label));
        if (long) arrow(svg,285,48,285,252,sizes.length > 1 ? 'Largo' : long.value,269,278);
        if (width) arrow(svg,103,151,217,151,sizes.length > 1 ? 'Pecho' : width.value,160,143);
        if (sleeve) { const text=document.createElementNS(ns,'text');text.setAttribute('x','24');text.setAttribute('y','104');text.textContent=sizes.length > 1 ? 'Manga' : sleeve.value;svg.append(text); }
        graph.append(svg);
      } else {
        const pairs = rows.filter(r => /[x×]/i.test(r.value)).filter((row,index,items) => items.findIndex(other => other.value.replace(/\s/g,'') === row.value.replace(/\s/g,'')) === index);
        const entries = pairs.length ? (towel ? pairs : pairs.slice(0,3)) : rows.slice(0,1);
        if (towel && entries.length > 1) {
          const svg = svgBase('');
          svg.querySelector('path').remove();
          svg.classList.add('emg-towel-overview');
          svg.setAttribute('viewBox','0 0 '+(entries.length*320)+' 330');
          entries.forEach((row,index) => {
            const sides=row.value.match(/\d+(?:[.,]\d+)?/g).slice(0,2).map(Number).sort((a,b)=>a-b);
            const offset=index*320;
            const left=offset+20, right=offset+220, top=90;
            const bottom=top+200*sides[0]/sides[1];
            const label=document.createElementNS(ns,'text');
            label.setAttribute('x',offset+150);label.setAttribute('y','28');
            label.setAttribute('text-anchor','middle');label.textContent=row.label;svg.append(label);
            const shape=document.createElementNS(ns,'path');
            shape.setAttribute('d','M'+left+' '+top+'H'+right+'V'+bottom+'H'+left+'Z');
            shape.setAttribute('fill','none');shape.setAttribute('stroke','#282828');shape.setAttribute('stroke-width','1.5');svg.append(shape);
            arrow(svg,left,top-18,right,top-18,'Largo: '+sides[1]+' cm',offset+120,top-30);
            arrow(svg,right+14,top,right+14,bottom,'Ancho',offset+277,top+(bottom-top)/2-8);
            const value=document.createElementNS(ns,'text');value.setAttribute('x',offset+277);
            value.setAttribute('y',top+(bottom-top)/2+12);value.setAttribute('text-anchor','middle');
            value.textContent=sides[0]+' cm';svg.append(value);
          });
          graph.append(svg);
          return;
        }
        entries.forEach(row => {
          const card=document.createElement('div');card.className='emg-piece';graph.append(card);
          const title=document.createElement('h3');title.textContent=row.label;card.append(title);

          if (towel) {
            const sides = row.value.match(/\d+(?:[.,]\d+)?/g).slice(0,2).map(Number).sort((a,b)=>a-b);
            const height = 310 * sides[0] / sides[1];
            const bottom = 65 + height;
            const svg = svgBase('M40 65H350V'+bottom+'H40Z');
            svg.classList.add('emg-towel-diagram');
            svg.setAttribute('viewBox', '0 0 480 '+(bottom+35));
            svg.querySelector('path').setAttribute('fill', 'none');
            arrow(svg,40,48,350,48,'Largo: '+sides[1]+' cm',195,32);
            arrow(svg,365,65,365,bottom,'Ancho: '+sides[0]+' cm',421,65+height/2);
            card.append(svg);
            return;
          }
          const values=row.value.match(/\d+(?:[.,]\d+)?/g) || [];
          if (/toalla|toall[oó]n/i.test(source.title) && values.length >= 2) {
            const sides = values.slice(0,2).map(v => Number(v.replace(',','.'))).sort((a,b)=>a-b);
            values[0]=String(sides[0]); values[1]=String(sides[1]);
          }
          const ratio = values.length >= 2 ? Number(values[0].replace(',','.')) / Number(values[1].replace(',','.')) : 1;
          const height = Math.min(195, 180 / ratio);
          const width = Math.min(180, 195 * ratio);
          const left = 155 - width/2;
          const top = 147.5 - height/2;
          const right = left+width;
          const bottom = top+height;
          const pillow = /almohada|funda/i.test(row.label);
          const fitted = /ajustable|bajera|colch[oó]n/i.test(row.label);
          const bedding = /s[aá]bana|cubrecama|cubre.?colch[oó]n|cobertor|funda/i.test(source.title);
          const svg=svgBase(bedding ? (fitted ? 'M42 155Q38 147 49 141L174 68Q180 64 192 67L267 92Q274 95 267 103L148 181Q142 187 131 184L49 165Q42 163 42 155Z' : 'M75 100L215 65L260 205L120 240Z') : 'M'+left+' '+top+'H'+right+'V'+bottom+'H'+left+'Z');
          if (bedding) {
            const defs=document.createElementNS(ns,'defs');
            const gradient=document.createElementNS(ns,'linearGradient');const gradientId='emg-fabric-'+Math.random().toString(36).slice(2);
            gradient.id=gradientId;gradient.setAttribute('x2','100%');gradient.setAttribute('y2','100%');
            [['0%','#ffffff'],['45%','#e7e4df'],['100%','#bbb6ad']].forEach(([offset,color])=>{const stop=document.createElementNS(ns,'stop');stop.setAttribute('offset',offset);stop.setAttribute('stop-color',color);gradient.append(stop);});
            defs.append(gradient);svg.prepend(defs);
            const fabric=svg.querySelector('path');fabric.setAttribute('fill','url(#'+gradientId+')');fabric.setAttribute('stroke','#8f8b82');
            const depth=fitted ? 46 : 7;
            const side=document.createElementNS(ns,'path');side.setAttribute('d',fitted ? 'M42 155L49 165L131 184Q142 187 148 181L267 103Q274 95 274 100V139Q274 146 267 151L148 229Q142 233 132 230L49 211Q42 209 42 200Z' : 'M120 240L260 205V'+(205+depth)+'L120 '+(240+depth)+'Z M75 100L120 240V'+(240+depth)+'L75 '+(100+depth)+'Z');side.setAttribute('fill','#c5c0b7');side.setAttribute('stroke','#8f8b82');svg.insertBefore(side,fabric);
            const seam=document.createElementNS(ns,'path');seam.setAttribute('d',fitted ? 'M47 166L132 185Q142 190 149 184L269 105 M143 189V227 M48 169Q44 181 48 205 M153 187Q149 208 153 224' : 'M84 106L210 75L248 200L125 230Z');seam.setAttribute('fill','none');seam.setAttribute('stroke','#fff');seam.setAttribute('stroke-opacity','.7');svg.append(seam);
          }
          if (fitted && bedding) {
            svg.setAttribute('viewBox','0 0 320 320');
            svg.querySelectorAll('path').forEach(path=>path.remove());
            const model=document.createElementNS(ns,'image');
            model.setAttribute('href','https://cdn.shopify.com/s/files/1/0609/5496/8134/files/modelo-sabana-ajustable-3d.png?v=1791674638');
            const modelWidth=Math.max(205,Math.min(265,250*Math.sqrt(ratio)));
            const modelHeight=Math.max(165,Math.min(205,185/Math.sqrt(ratio)));
            model.setAttribute('x',String((300-modelWidth)/2));model.setAttribute('y','54');model.setAttribute('width',String(modelWidth));model.setAttribute('height',String(modelHeight));model.setAttribute('preserveAspectRatio','none');svg.append(model);
          }
          if (pillow && bedding) {
            svg.querySelectorAll('path').forEach(path=>path.remove());
            const gradient=svg.querySelector('linearGradient');
            const fill=gradient ? 'url(#'+gradient.id+')' : '#f5f3ee';
            function cushion(dx,dy){
              const p=document.createElementNS(ns,'path');
              p.setAttribute('d','M'+(48+dx)+' '+(133+dy)+'Q'+(44+dx)+' '+(114+dy)+' '+(67+dx)+' '+(106+dy)+'L'+(204+dx)+' '+(71+dy)+'Q'+(223+dx)+' '+(66+dy)+' '+(232+dx)+' '+(83+dy)+'L'+(265+dx)+' '+(142+dy)+'Q'+(273+dx)+' '+(160+dy)+' '+(251+dx)+' '+(168+dy)+'L'+(108+dx)+' '+(206+dy)+'Q'+(87+dx)+' '+(212+dy)+' '+(78+dx)+' '+(192+dy)+'Z');
              p.setAttribute('fill',fill);p.setAttribute('stroke','#bcb8af');p.setAttribute('stroke-width','1');svg.append(p);
              const seam=document.createElementNS(ns,'path');seam.setAttribute('d','M'+(58+dx)+' '+(125+dy)+'L'+(91+dx)+' '+(187+dy)+'Q'+(98+dx)+' '+(199+dy)+' '+(111+dx)+' '+(195+dy)+'L'+(251+dx)+' '+(158+dy));seam.setAttribute('fill','none');seam.setAttribute('stroke','#fff');svg.append(seam);
            }
            if(/^2\b/.test(row.label)) cushion(-7,-18);
            cushion(0,0);
            if(values[0]) arrow(svg,30,138,65,204,'Ancho: '+values[0]+' cm',65,235);
            if(values[1]) arrow(svg,109,224,264,183,'Largo: '+values[1]+' cm',204,252);
          } else if (fitted && bedding) {
            if(values[0]) arrow(svg,38,217,148,245,'Ancho: '+values[0]+' cm',83,270);
            if(values[1]) arrow(svg,166,245,278,141,'Largo: '+values[1]+' cm',237,294);
            if(values[2]) arrow(svg,292,105,292,154,'Alto / fuelle: '+values[2]+' cm',220,35);
          } else if (bedding) {
            svg.querySelectorAll('path').forEach(path=>path.remove());
            const fabric=document.createElementNS(ns,'path');
            const gradient=svg.querySelector('linearGradient');
            fabric.setAttribute('d','M62 108Q140 81 213 64L259 211Q190 222 111 252L62 108Z');
            fabric.setAttribute('fill',gradient ? 'url(#'+gradient.id+')' : '#f6f4ef');fabric.setAttribute('stroke','#aaa59b');svg.append(fabric);
            const fold=document.createElementNS(ns,'path');fold.setAttribute('d','M73 116Q144 90 206 77 M111 236Q177 212 247 204 M87 146Q132 140 155 125');fold.setAttribute('fill','none');fold.setAttribute('stroke','#fff');fold.setAttribute('stroke-width','2');svg.append(fold);
            if(values[0]) arrow(svg,57,89,209,46,'Ancho: '+values[0]+' cm',125,31);
            if(values[1]) arrow(svg,232,60,278,208,'Largo: '+values[1]+' cm',216,280);
          } else if (values.length>=2) {
            arrow(svg,left,top-18,right,top-18,'Ancho: '+values[0]+' cm',155,top-27);
            arrow(svg,right+18,top,right+18,bottom,'Largo: '+values[1]+' cm',155,bottom+30);
          } else { arrow(svg,65,270,245,270,row.value,155,289); }
          card.append(svg);
        });
      }
    });
  }
  document.addEventListener('change',event=>{
    if(!event.target.closest('#product-template')) return;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      document.querySelectorAll('[data-measure-guide]').forEach(guide=>{
        delete guide.dataset.ready;
        guide.querySelector('[data-measure-rows]').replaceChildren();
        guide.querySelector('[data-measure-graph]').replaceChildren();
      });
      init();
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

